export default [
  {
    title: 'Material Type',
    lines: [
      'For Rigid-Flex boards we recommend the FR4 Tg 170 material with a RoHS finish.',
      'For Flexible boards most customers select Polyimide as base material.',
    ],
  },
  {
    title: 'Finish Type',
    lines: [
      'We suggest to select ENIG finish for best results.',
    ],
  },
];
